
export class AssetsPath {
    public static readonly images = 'image/';
    public static readonly path = 'assets/';

    private static get assetBaseUrl(): string {
      return (globalThis as any).__env?.assetBaseUrl || '';
    }
    public static readonly brandingAssetsStudent = {
        favicon: `${AssetsPath.assetBaseUrl}${AssetsPath.path}${AssetsPath.images}favicon.ico`,
        favicon_ico: `${AssetsPath.assetBaseUrl}${AssetsPath.path}${AssetsPath.images}favicon.ico`,
        logo: `${AssetsPath.assetBaseUrl}${AssetsPath.path}${AssetsPath.images}new-university-logo.png`,
        profile_image: `${AssetsPath.assetBaseUrl}${AssetsPath.path}${AssetsPath.images}user-profile.png`,
    };
}

(globalThis as any).AssetsPath = AssetsPath;